export interface DiaDoResumo {
  data: string;
  texto: string;
}

// Um trecho começa com a data seguida de ":" ou "," no início do texto ou logo
// depois de ". " / "; ". Data no meio da frase ("em 28/08, confirmou") não quebra.
const DATA = String.raw`(?:Entre\s+)?\d{2}\/\d{2}(?:\s*(?:[–-]|e|a)\s*\d{2}\/\d{2})?`;
const INICIO_DE_TRECHO = new RegExp(String.raw`(?:^|(?<=[.;]\s))(?=${DATA}\s*[:,])`);
const DATA_NO_INICIO = new RegExp(String.raw`^(${DATA})\s*[:,]\s*`);

function capitalizar(texto: string): string {
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

/**
 * Quebra o resumo em prosa ("04/09: ... 09/09–11/09: ...") num dia por linha,
 * juntando trechos seguidos do mesmo dia. Devolve null quando o texto não tem
 * datas suficientes para virar linha do tempo: aí a ficha mostra a prosa.
 */
export function resumoPorDia(resumo: string): DiaDoResumo[] | null {
  const dias: DiaDoResumo[] = [];
  for (const trecho of resumo.split(INICIO_DE_TRECHO)) {
    const texto = trecho.trim();
    if (!texto) continue;
    const match = texto.match(DATA_NO_INICIO);
    if (!match) {
      if (dias.length === 0) return null;
      dias[dias.length - 1].texto += ` ${texto}`;
      continue;
    }
    const data = match[1].replace(/^Entre\s+/, "").replace(/\s*(?:[–-]|e|a)\s*/, " a ");
    const corpo = capitalizar(texto.slice(match[0].length).replace(/;$/, "."));
    const anterior = dias[dias.length - 1];
    if (anterior?.data === data) {
      anterior.texto += ` ${corpo}`;
    } else {
      dias.push({ data, texto: corpo });
    }
  }
  return dias.length >= 2 ? dias : null;
}
